(() => {
  if (window.__WN_REVIEW_WIDGET_LOCALIZER__) return;
  window.__WN_REVIEW_WIDGET_LOCALIZER__ = true;

  const locale = () => { const full = String(document.documentElement.lang || 'nl').toLowerCase(); return full.startsWith('pt-br') ? 'pt-BR' : full.startsWith('pt') ? 'pt-PT' : full.split('-')[0]; };
  const supported = ['nl', 'en', 'de', 'fr', 'es', 'it', 'pl', 'sv', 'cs', 'pt-PT', 'pt-BR'];

  const copy = {
    nl: { title: 'Klantbeoordelingen', empty: 'Schrijf als eerste een beoordeling', write: 'Schrijf een beoordeling', sort: 'Sorteren op', recent: 'Meest recent', high: 'Hoogste beoordeling', low: 'Laagste beoordeling', photos: 'Alleen foto’s', more: 'Meer', less: 'Minder' },
    en: { title: 'Customer Reviews', empty: 'Be the first to write a review', write: 'Write a review', sort: 'Sort by', recent: 'Most recent', high: 'Highest rating', low: 'Lowest rating', photos: 'Photos only', more: 'More', less: 'Less' },
    de: { title: 'Kundenbewertungen', empty: 'Schreiben Sie die erste Bewertung', write: 'Bewertung schreiben', sort: 'Sortieren nach', recent: 'Neueste', high: 'Höchste Bewertung', low: 'Niedrigste Bewertung', photos: 'Nur Fotos', more: 'Mehr', less: 'Weniger' },
    fr: { title: 'Avis clients', empty: 'Soyez le premier à laisser un avis', write: 'Écrire un avis', sort: 'Trier par', recent: 'Les plus récents', high: 'Note la plus élevée', low: 'Note la plus basse', photos: 'Photos uniquement', more: 'Plus', less: 'Moins' },
    es: { title: 'Opiniones de clientes', empty: 'Sé el primero en escribir una opinión', write: 'Escribir una opinión', sort: 'Ordenar por', recent: 'Más recientes', high: 'Valoración más alta', low: 'Valoración más baja', photos: 'Solo fotos', more: 'Más', less: 'Menos' },
    it: { title: 'Recensioni dei clienti', empty: 'Scrivi la prima recensione', write: 'Scrivi una recensione', sort: 'Ordina per', recent: 'Più recenti', high: 'Valutazione più alta', low: 'Valutazione più bassa', photos: 'Solo foto', more: 'Altro', less: 'Meno' }
  };

  Object.assign(copy, {"pl":{"title":"Opinie klientów","empty":"Napisz pierwszą opinię","write":"Napisz opinię","sort":"Sortuj według","recent":"Najnowsze","high":"Najwyższa ocena","low":"Najniższa ocena","photos":"Tylko zdjęcia","more":"Więcej","less":"Mniej"},"sv":{"title":"Kundomdömen","empty":"Bli först med att skriva ett omdöme","write":"Skriv ett omdöme","sort":"Sortera efter","recent":"Senaste","high":"Högsta betyg","low":"Lägsta betyg","photos":"Endast bilder","more":"Mer","less":"Mindre"},"cs":{"title":"Hodnocení zákazníků","empty":"Napište první hodnocení","write":"Napsat hodnocení","sort":"Seřadit podle","recent":"Nejnovější","high":"Nejvyšší hodnocení","low":"Nejnižší hodnocení","photos":"Pouze fotografie","more":"Více","less":"Méně"},"pt-PT":{"title":"Avaliações de clientes","empty":"Seja o primeiro a avaliar","write":"Escrever uma avaliação","sort":"Ordenar por","recent":"Mais recentes","high":"Classificação mais alta","low":"Classificação mais baixa","photos":"Apenas fotos","more":"Mais","less":"Menos"},"pt-BR":{"title":"Avaliações dos clientes","empty":"Seja o primeiro a avaliar","write":"Escrever uma avaliação","sort":"Ordenar por","recent":"Mais recentes","high":"Maior nota","low":"Menor nota","photos":"Somente fotos","more":"Ver mais","less":"Ver menos"}});

  const groups = {
    title: ['Customer Reviews', 'Customer reviews', 'Klantbeoordelingen', 'Kundenbewertungen', 'Avis clients', 'Opiniones de clientes', 'Recensioni dei clienti'],
    empty: ['Be the first to write a review', 'Schrijf als eerste een beoordeling', 'Wees de eerste om een beoordeling te schrijven', 'Schreiben Sie die erste Bewertung', 'Soyez le premier à laisser un avis', 'Sé el primero en escribir una opinión', 'Scrivi la prima recensione'],
    write: ['Write a review', 'Schrijf een beoordeling', 'Bewertung schreiben', 'Écrire un avis', 'Escribir una opinión', 'Scrivi una recensione'],
    sort: ['Sort by', 'Sorteren op', 'Sortieren nach', 'Trier par', 'Ordenar por', 'Ordina per'],
    recent: ['Most Recent', 'Most recent', 'Meest recent', 'Neueste', 'Les plus récents', 'Más recientes', 'Più recenti'],
    high: ['Highest Rating', 'Highest rating', 'Hoogste beoordeling', 'Höchste Bewertung', 'Note la plus élevée', 'Valoración más alta', 'Valutazione più alta'],
    low: ['Lowest Rating', 'Lowest rating', 'Laagste beoordeling', 'Niedrigste Bewertung', 'Note la plus basse', 'Valoración más baja', 'Valutazione più bassa'],
    photos: ['Only Pictures', 'Photos only', 'Alleen foto’s', "Alleen foto's", 'Nur Fotos', 'Photos uniquement', 'Solo fotos'],
    more: ['See more', 'More', 'Meer', 'Mehr', 'Plus', 'Más', 'Altro'],
    less: ['See less', 'Less', 'Minder', 'Weniger', 'Moins', 'Menos', 'Meno']
  };

  Object.values(copy).forEach(lang => { for (const [key, value] of Object.entries(lang)) { if (groups[key] && !groups[key].includes(value)) groups[key].push(value); } });

  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
  const keyFor = value => {
    const normalized = normalize(value);
    if (!normalized) return null;
    return Object.keys(groups).find(key => groups[key].some(item => normalize(item) === normalized)) || null;
  };

  const translateNode = node => {
    const parent = node.parentElement;
    if (!parent || ['SCRIPT', 'STYLE', 'TEXTAREA'].includes(parent.tagName)) return;
    const original = node.nodeValue || '';
    const key = keyFor(original);
    const lang = locale();
    if (!key || !supported.includes(lang)) return;
    const replacement = copy[lang][key];
    if (!replacement || normalize(original) === normalize(replacement)) return;
    const leading = (original.match(/^\s*/) || [''])[0];
    const trailing = (original.match(/\s*$/) || [''])[0];
    node.nodeValue = `${leading}${replacement}${trailing}`;
  };

  const apply = () => {
    const lang = locale();
    if (!supported.includes(lang)) return;
    document.querySelectorAll('.wn-apps--reviews .jdgm-widget, .wn-apps--reviews [class*="jdgm"], .wn-editorial-reviews .jdgm-widget, .wn-editorial-reviews [class*="jdgm"]').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      let node;
      while ((node = walker.nextNode())) nodes.push(node);
      nodes.forEach(translateNode);
    });
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  };

  const start = () => {
    apply();
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    let rounds = 0;
    const timer = setInterval(() => {
      apply();
      rounds += 1;
      if (rounds >= 20) clearInterval(timer);
    }, 500);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
